








































































































import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { QueryBuilder } from '@/classes/QueryBuilder';
import moment from 'moment';
import DateRangeForReport from '@/components/DateRangeForReports.vue';
import { Tag } from 'element-ui';
import UserLazydropdown from '@/components/lazyDropdown/UserLazydropdown.vue';
import TerritoryCascaderDropdown from "@/components/resources-autocomplete/TerritoryCascaderDropdown.vue";
import PaginationComponentMixin from '@/mixins/PaginationComponent';

const flatPicker = require('vue-flatpickr-component');
@Component({
  components: {
    TerritoryCascaderDropdown,
    UserLazydropdown,
    flatPicker,
    DateRangeForReport,
    [Tag.name]: Tag
  }
})
export default class DayInDayOutReport extends Mixins(PaginationComponentMixin) {
  public downloading: boolean = false;
  public loading: boolean = false;
  public dayInDayOutReports = [];
  public printing: boolean = false;
  public rangeSelectConfig = {
    allowInput: true,
    disable: [
      function (range: Date) {
        return moment().diff(range) < 0;
      }
    ]
  };
  public filters: any = {
    range: '',
    territory_id: null,
    user_id: null,
  };

  public onClickGenerate() {
    this.pagination.currentPage = 1;
    this.fetchReport();
  }
  @Watch('pagination.currentPage', { deep: true })
  async fetchReport() {
    this.loading = true;
    this.$http.get(this.$api3(`/daily-attendance${this.$toQueryString(this.filters)}&page=${this.pagination.currentPage}`)).then(response => {
      this.dayInDayOutReports = response.data.dailyAttendance;
      this.setPagination(response.data);
      if (this.dayInDayOutReports.length == 0) {
        this.$notify({
          type: 'warning',
          message: 'There is no reports set in selected filters',
          title: 'No data found!',
        });
      }
    })
      .catch((error) => {
        (
          this.$refs.formValidator as Vue & {
            setErrors: (errors: []) => any;
          }
        ).setErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  async onClickDownload() {
    this.downloading = true;
    try {
      let {
        data,
        headers
      } = await this.$http.get(this.$api3(`/daily-attendance${this.$toQueryString(this.filters)}&download`), {
        responseType: 'arraybuffer'
      });
      const blob = await new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement("a");
      link.href = await URL.createObjectURL(blob);
      link.download = this.$getFileNameFromContentDisposition(headers);
      link.click();
    } catch (e) {
      this.$notify({
        title: 'Something wants wrong!',
        type: 'warning',
        message: 'Unable to download reports.',
      })
    } finally {
      this.downloading = false;
    }
  }

  formattedRange() {
      if (!this.filters.range) return '';
      const dates = this.filters.range.split(',');
      return dates.length === 2 ? `${dates[0]} to ${dates[1]}` : this.filters.range;
    }
}
